import { render, staticRenderFns } from "./FAssetDetail.vue?vue&type=template&id=c4f6d970&scoped=true&"
import script from "./FAssetDetail.vue?vue&type=script&lang=js&"
export * from "./FAssetDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f6d970",
  null
  
)

export default component.exports